import React, {Component} from 'react';
import {Row} from 'antd';
import WrappedNormalTotpForm from './totp';
import {connect} from "react-redux";

class TotpView extends Component {

    render() {

        let search = ((this.props.location.state || {}).from || {}).search;
        let demoLogin = false;
        if (search) {
            demoLogin = search.includes("demo=true");
        }

        const url = window.location.href.split('?')[1];
        let displayMessage = null;
        let resolution = null;
        if (url) {
            var partsOfUrl = url.split('&');
            partsOfUrl.forEach((part) => {
                var key = part.split('=')[0];
                var value = part.split('=')[1];
                if (key === 'message') {
                    displayMessage = value;
                } else if (key === 'resolution') {
                    resolution = value;
                }
            });
        }

        return (
            <Row className="login-mp">
                <WrappedNormalTotpForm demoLogin={demoLogin} message={displayMessage} resolution={resolution}/>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return state.loginAlerts;
}

export default connect(mapStateToProps)(TotpView);
